import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5466_9747)">
      <path
        d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
        fill="#ECEDEE"
      />
      <path
        d="M18.5783 5.422H5.42163V16.8768C5.42163 17.8164 6.18335 18.5781 7.12297 18.5781H9.03325V9.03383H16.688C17.732 9.03383 18.5783 8.18748 18.5783 7.14345V5.422Z"
        fill="#697177"
      />
      <path
        d="M16.9983 9.8127H9.84264V17.4446C9.84264 18.0706 10.3514 18.5781 10.8625 18.5781H11.996V12.0301H15.9702C16.538 12.0301 16.9983 11.6552 16.9983 10.9596V9.8127Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_5466_9747">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
